import React, { useContext } from 'react';
import { func, shape } from 'prop-types';
import { Alert } from '@thd-olt-component-react/alert';
import { ExperienceContext, useStore } from '@thd-nucleus/experience-context';
import { productShape } from '../../helpers/pod-fulfillment-utils';
import { CheckNearByStore } from './CheckNearbyStore';

export const LimitedAvailability = ({
  product,
  onCheckNearbyStoresClick
}) => {
  const {
    channel
  } = useContext(ExperienceContext);

  const { storeId, storeName } = useStore();
  // @TODO: Need store phone from store details query.
  const phone = '(512)238-0820';

  if (!(storeName && storeId)) {
    return null;
  }

  const storeMessage = `Limited stock at ${storeName}`;

  return (
    <>
      <Alert type="warning" message={storeMessage} inline />
      {channel !== 'mobile' && (
        <div className="store__new-line">
          <CheckNearByStore
            product={product}
            onCheckNearbyStoresClick={onCheckNearbyStoresClick}
          />
        </div>
      )}
    </>
  );
};

LimitedAvailability.propTypes = {
  product: shape({ productShape }).isRequired,
  onCheckNearbyStoresClick: func
};

LimitedAvailability.defaultProps = {
  onCheckNearbyStoresClick: null
};
